import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ActivityHeaderLayout from '@monorepo/shared/src/components/activities/ActivityHeaderLayout';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import { ApplicationSection } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { TelemetryEvents } from '@monorepo/shared/src/types';
import TabBar from 'components/common/TabBar';
import { AppRoutes } from 'types';
import { getLetters } from '@monorepo/shared/src/util/text-util';
import getTabComponentList from './components/TabComponentList';
import getTabList from './components/TabList';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('letterTeaching', key, options);

const TabIndex = {
  'letter-book': 0,
  'practice-book': 1,
  'teachers-guide': 2,
  resources: 3,
};

const LetterTeachingTabView: React.FC = () => {
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.VIEW_TAB);
  const { letter, tab } = useParams();
  const letters = getLetters(letter ?? '');
  const tabComponentList: Array<{ Component: React.FC<any> }> = useMemo(
    () => getTabComponentList(),
    []
  );
  const tabList: Array<{ Component: React.FC<any> }> = useMemo(() => getTabList(), []);
  const omitRoutes = useTrialUserOmitRoutes();
  const createTelemetryEvent = (newTab) => {
    fireEvent({
      section: ApplicationSection.LETTER_LEARNING,
      tab: newTab,
    });
  };

  return (
    <ActivityHeaderLayout
      title={`${t('letter')} ${letters}`}
      hasTogglePageView={tab !== AppRoutes.RESOURCES}
      showCloseButton={false}
      omitRoutes={omitRoutes}
    >
      <TabBar
        tabs={tabList}
        tabViews={tabComponentList}
        defaultTabIndex={TabIndex[tab ?? 0]}
        handleStateChange={true}
        handleOnClick={createTelemetryEvent}
      />
    </ActivityHeaderLayout>
  );
};

export default LetterTeachingTabView;
